module.exports = __webpack_public_path__ + "img/expertos.a946cc69.jpg";